import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {ResponseData} from '../nest-responses';
import {RequestEditEISSetting, ResponseGetEISSetting} from './eis-setting.dto';

@Injectable()
export class EisSettingApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'eis-setting';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public geteissetting(): Observable<ResponseData<ResponseGetEISSetting[]>> {
    const method: string = 'GET';
    const func: string = 'geteissetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetEISSetting[]>>(method, url, params, urlParams, body);
  }

  public eissetting(payload: RequestEditEISSetting[]): Observable<any> {
    const method: string = 'POST';
    const func: string = 'eissetting';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/eis-setting.api.ts